import { render } from "./LabelFilter.vue?vue&type=template&id=509716ce&scoped=true"
import script from "./LabelFilter.vue?vue&type=script&lang=js"
export * from "./LabelFilter.vue?vue&type=script&lang=js"

import "./LabelFilter.vue?vue&type=style&index=0&id=509716ce&scoped=true&lang=less"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509716ce"]])

export default __exports__